import { render, staticRenderFns } from "./SetupNotifyReceiver.vue?vue&type=template&id=efd3aa32"
import script from "./SetupNotifyReceiver.vue?vue&type=script&lang=js"
export * from "./SetupNotifyReceiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports